Object.defineProperty(exports, "__esModule", {
  value: true
});

var requestIdleCallbackFallback = function requestIdleCallbackFallback(handler) {
  var startTime = Date.now();
  var interval = setTimeout(function () {
    handler({
      didTimeout: false,
      timeRemaining: function timeRemaining() {
        return Math.max(0, 50.0 - (Date.now() - startTime));
      }
    });
    clearTimeout(interval);
    interval = null;
  }, 1000);
  return interval;
};

var cancelIdleCallbackFallback = function cancelIdleCallbackFallback(id) {
  clearTimeout(id);
};

exports.requestIdleCallbackFallback = requestIdleCallbackFallback;
exports.cancelIdleCallbackFallback = cancelIdleCallbackFallback;